module.exports = __webpack_public_path__ + "img/li_da_you_hui_quan.c56785e0.png";